import type { IconData } from '@stacksjs/iconify-core'

export const infinity: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M463.2 176.805a112 112 0 0 0-158.39 0l-48.57 48.568l-48.573-48.573a112 112 0 1 0 0 158.392l48.568-48.569l48.57 48.569A112 112 0 1 0 463.2 176.805M185.04 312.569a80 80 0 1 1 0-113.138l55.2 55.2v2.746Zm255.528 0a80 80 0 0 1-113.136 0l-55.2-55.2v-2.744l55.2-55.2a80 80 0 1 1 113.136 113.144\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default infinity
